import styled from 'styled-components';

const Box = styled.div<{ width?: number; height?: number }>`
  padding: 16px;
  border: 1px solid ${(props) => props.theme.palette.greyscale[3]};
  border-radius: 4px;
  width: ${(props) => (props.width ? `${props.width}px` : 'auto')};
  height: ${(props) => (props.height ? `${props.height}px` : 'auto')};
`;

export { Box };
